<template lang="pug">
.content
    setting-title(
        title="代码管理",
    )
        div#backToReport 完成本页操作后可
            router-link(to="/web/overview") 查看分析
    ul.tab
        li.tab-item(v-for="item in tabViews")
            .tabview-btn(
                @click.prevent="changeViewTo(item.comp)",
                :class="{ active: currentComp === item.comp}"
            ) {{item.title}}
    
    get-code(v-if="currentComp === 'get-code'", @viewChange="changeViewTo($event)")
    install-code(v-if="currentComp === 'install-code'")
    check-code(v-if="currentComp === 'check-code'")
</template>

<script>
    import GetCodeComp from './gencode_get.vue';
    import InstallCodeComp from './gencode_install.vue';
    import CheckCodeComp from './gencode_check.vue';

    export default {
        components: {
            'get-code': GetCodeComp,
            'install-code': InstallCodeComp,
            'check-code': CheckCodeComp
        },
        data () {
            return {
                currentComp: 'get-code',
                tabViews: [{
                    comp: 'get-code',
                    title: '代码获取'
                }, {
                    comp: 'install-code',
                    title: '自动安装'
                }, {
                    comp: 'check-code',
                    title: '代码检查'
                }]
            }
        },
        methods: {
            changeViewTo(comp) {
                let view = _.find(this.tabViews, { comp });
                if (view) {
                    this.currentComp = view.comp;
                }
            }
        },
        created () {
            
        }
    }
</script>



// WEBPACK FOOTER //
// gencode.vue?3bbc5622